'use strict';

class SalesmenController {
  /* @ngInject */
  constructor(SalesmenService, $scope, $q) {
    Object.assign(this, {
      SalesmenService,
      $scope,
      $q
    });

    this.query = {
      include: [],
      where: {},
      limit: 10,
      page: 1,
      order: 'name ASC'
    };

    this.getSalesmen();

    this.onPagination = () => {
      this.getSalesmen();
    };
  }

  getSalesmen() {
    let qOpts = JSON.parse(JSON.stringify(this.query));
    if (this.whereName) {
      qOpts.where.name = {
        ilike: `%${this.whereName}%`
      };
    }

    let queryReady = this.SalesmenService.getModels(qOpts).then(salesmen => {
      this.salesmen = salesmen;
    });
    let countReady = this.SalesmenService.getCount(qOpts).then(result => {
      this.salesmenCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }
}

export default SalesmenController;
